module.exports = __webpack_public_path__ + "./docs/img/icon-star.083a9255232651e8b03ed92c6dd76142.svg";